import { IconCheckmarkCircle } from '@tocktix/pantry';
import {
  PartyForCard,
  getGuestProfile,
} from 'components/service/party/partyRedesignCard/partyType';
import { Typography } from 'bento';
import { currentBusinessIdSelector } from 'selectors/currentBusinessSelector';
import { dashboard } from 'types';
import { getBusinessGuestProfile } from 'utils/guestProfileUtils';
import { partyCardCompactDescriptionCssDefs } from 'components/service/party/partyRedesignCard/partyCardCssDefs';
import { useSelector } from 'react-redux';
import React from 'react';

interface Props {
  party: PartyForCard;
}

export const PartyVisitCount: React.FC<Props> = ({ party }) => {
  const businessId = useSelector(currentBusinessIdSelector);
  const guestProfile = getGuestProfile(party);

  // When no guestProfile is found, visitCount is colored 'subtle'
  const noGuestProfile = guestProfile === undefined;
  let visitCount = 0; // Default to 0. When data is loading show 0 visits.

  if (guestProfile) {
    const businessGuestProfile: dashboard.IBusinessGuestProfile | null | undefined =
      getBusinessGuestProfile(guestProfile, businessId);

    if (businessGuestProfile?.pastVisits !== undefined) {
      visitCount = businessGuestProfile.pastVisits ?? 0;
    }
  }

  return (
    <>
      <IconCheckmarkCircle
        css={partyCardCompactDescriptionCssDefs.visitCountIcon({ noGuestProfile })}
      />
      <Typography
        variant="overline"
        css={partyCardCompactDescriptionCssDefs.visitCount({ noGuestProfile })}
      >
        {visitCount}
      </Typography>
    </>
  );
};

export default PartyVisitCount;
